



import styled, { keyframes } from "styled-components";

const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const MainDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  background: #F0F2FA;
  overflow: hidden;
`;

export const ContentWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 28px 32px 5px 32px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
  box-sizing: border-box;
  border-top: 5px solid #6366F1;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 12px;

  .leftSide {
    font-weight: 900;
    font-size: 28px;
    line-height: 1.1;
    color: #0F172A;
    letter-spacing: -0.6px;
  }

  .rightSide {
    display: flex;
    gap: 10px;
  }
`;

export const GradientButton = styled.button`
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(79,70,229,0.3);
  transition: all 0.18s ease;

  &:hover {
    background: linear-gradient(135deg, #4338CA 0%, #6D28D9 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(79,70,229,0.4);
  }
`;

export const OutlineButton = styled.button`
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  border: 1.5px solid #C7D2FE;
  background: #fff;
  color: #4F46E5;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    background: #EEF2FF;
    border-color: #A5B4FC;
  }
`;

/* ── Summary cards ─────────────────────────── */
export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 16px;
  flex-shrink: 0;

  @media (max-width: 1100px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 640px)  { grid-template-columns: repeat(2, 1fr); }
`;

export const SummaryCard = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px 12px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04);
  border: 1px solid ${({ color }) => color}22;
  animation: ${fadeSlideIn} 0.3s ease both;
  animation-delay: ${({ idx }) => (idx || 0) * 0.06}s;
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    background: ${({ color }) => color};
    border-radius: 14px 14px 0 0;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -12px; right: -12px;
    width: 64px; height: 64px;
    border-radius: 50%;
    background: ${({ color }) => color}10;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px ${({ color }) => color}1F;
  }
`;

export const SummaryValue = styled.div`
  font-size: 26px;
  font-weight: 800;
  color: ${({ color }) => color};
  line-height: 1;
  letter-spacing: -1px;
  margin-bottom: 6px;
  font-variant-numeric: tabular-nums;
`;

export const SummaryLabel = styled.div`
  font-size: 9.5px;
  color: #94A3B8;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

/* ── Filters ──────────────────────────────── */
export const FilterRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden; /* remove vertical scrollbar */
  flex-wrap: nowrap;
  padding-bottom: 6px;
  flex-shrink: 0;
  scrollbar-width: thin;
  scrollbar-color: #C7D2FE transparent;

  &::-webkit-scrollbar {
    height: 4px;
    width: 0; /* prevent vertical track in WebKit */
  }

  &::-webkit-scrollbar-thumb {
    background: #C7D2FE;
    border-radius: 10px;
  }

  &::-webkit-scrollbar:vertical {
    width: 0;
  }
`;
export const StyledSelectWrap = styled.div`
  flex-shrink: 0;

  .ant-select-selector {
    min-height: 42px !important;
    height: 42px !important;
    border-radius: 12px !important;
    border: 1px solid #D7DDED !important;
    display: flex; align-items: center;
    padding: 0 12px !important;
    box-shadow: none !important;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap !important;
  }
  .ant-select-selector::-webkit-scrollbar { height: 3px; }
  .ant-select-selector::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 10px; }

  .ant-select-selection-item,
  .ant-select-selection-placeholder,
  .ant-select-selection-search-input {
    height: 40px !important; line-height: 40px !important;
    display: flex; align-items: center;
    font-size: 13px; font-weight: 500;
  }
  .ant-select-selection-overflow {
    flex-wrap: nowrap !important;
    height: 40px;
    align-items: center;
  }
  .ant-select-selection-item {
    height: 26px !important;
    line-height: 24px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .ant-select-arrow { color: #94A3B8; }
  .ant-select-focused .ant-select-selector {
    border-color: #818CF8 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.08) !important;
  }
  .ant-select-selector:hover { border-color: #A5B4FC !important; }
`;

export const StyledInputWrap = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  .ant-input-affix-wrapper {
    width: 220px;
    height: 42px !important;
    border-radius: 12px !important;
    border: 1px solid #D7DDED !important;
    box-shadow: none !important;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 12px !important;
  }
  .ant-input-affix-wrapper .ant-input {
    height: 100% !important;
    font-size: 13px;
    font-weight: 500;
  }
  .ant-input-affix-wrapper:hover { border-color: #A5B4FC !important; }
  .ant-input-affix-wrapper-focused {
    border-color: #818CF8 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.08) !important;
  }
`;

export const StyledRangePickerWrap = styled.div`
  flex-shrink: 0;

  .ant-picker {
    height: 42px !important;
    border-radius: 12px !important;
    border: 1px solid #D7DDED !important;
    box-shadow: none !important;
  }
  .ant-picker:hover { border-color: #A5B4FC !important; }
  .ant-picker-focused {
    border-color: #818CF8 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.08) !important;
  }
`;

/* ── Table ────────────────────────────────── */

export const TableWrap = styled.div`
  width: 100%;
  height: auto;
  overflow-x: auto;
  overflow-y: auto;
  display: block;        /* instead of flex */
  flex-grow: 0;          /* prevent forced stretch */
  min-height: 0;
  max-height: calc(100vh - 300px); /* scroll only when many rows */
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06), 0 6px 28px rgba(0,0,0,0.07);
  background: #fff;

  &::-webkit-scrollbar { width: 6px; height: 6px; }
  &::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 10px; }
`;


export const MainTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;

  & th {
    height: 44px;
    background: #F8F9FF;
    font-weight: 700;
    padding: 6px 12px;
    text-align: left;
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    color: #64748B;
    white-space: nowrap;
    border-bottom: 1.5px solid #E4E9F8;
  }

  & tbody tr {
    transition: background-color 0.15s ease;
  }

  & tbody tr:hover td {
    background: #F5F6FF !important;
  }

  & td {
    height: 50px;
    border-bottom: 1px solid #F1F4FB;
    padding: 6px 12px;
    font-weight: 500;
    font-size: 13px;
    color: #334155;
  }

  & tbody tr:last-child td {
    border-bottom: none;
  }
`;

/* ── Chips / pills reused across cells ───────────── */
const ACCOUNT_PALETTE = [
  { bg: "#EDE9FE", fg: "#5B21B6" },
  { bg: "#FCE7F3", fg: "#9D174D" },
  { bg: "#D1FAE5", fg: "#065F46" },
  { bg: "#FEF3C7", fg: "#92400E" },
  { bg: "#DBEAFE", fg: "#1E40AF" },
  { bg: "#FFE4E6", fg: "#9F1239" },
  { bg: "#E0E7FF", fg: "#3730A3" },
  { bg: "#FDE68A", fg: "#713F12" },
];

const hashStr = (str) => {
  let h = 5381;
  for (let i = 0; i < (str || "").length; i++) {
    h = ((h << 5) + h) ^ str.charCodeAt(i);
    h = h & h;
  }
  return Math.abs(h);
};

export const getAccountColor = (name) =>
  ACCOUNT_PALETTE[hashStr(name || "") % ACCOUNT_PALETTE.length];

export const AccountChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 7px;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ bg }) => bg};
  color: ${({ fg }) => fg};
`;

const PRIORITY_STYLE = {
  P0: { bg: "#FEE2E2", fg: "#991B1B", border: "#FCA5A5" },
  P1: { bg: "#FEF3C7", fg: "#92400E", border: "#FDE68A" },
  P2: { bg: "#DBEAFE", fg: "#1E40AF", border: "#93C5FD" },
  P3: { bg: "#F1F5F9", fg: "#475569", border: "#CBD5E1" },
};

export const PriorityPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ p }) => (PRIORITY_STYLE[p]?.bg) || "#F1F5F9"};
  color: ${({ p }) => (PRIORITY_STYLE[p]?.fg) || "#475569"};
  border: 1px solid ${({ p }) => (PRIORITY_STYLE[p]?.border) || "#CBD5E1"};
`;

const STATUS_STYLE = {
  open: { bg: "#D1FAE5", fg: "#065F46", border: "#6EE7B7" },
  "on hold": { bg: "#FEF3C7", fg: "#92400E", border: "#FDE68A" },
  closed: { bg: "#F1F5F9", fg: "#64748B", border: "#CBD5E1" },
};

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: ${({ s }) => (STATUS_STYLE[(s || "").toLowerCase()]?.bg) || "#F1F5F9"};
  color: ${({ s }) => (STATUS_STYLE[(s || "").toLowerCase()]?.fg) || "#64748B"};
  border: 1px solid ${({ s }) => (STATUS_STYLE[(s || "").toLowerCase()]?.border) || "#CBD5E1"};
`;

export const NumPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  background: ${({ bg }) => bg || "#F1F5F9"};
  color: ${({ fg }) => fg || "#64748B"};
`;

/* ── Pagination ──────────────────────────── */
export const PaginationSelectWrapper = styled.div`
  .ant-select-selector {
    height: 34px !important;
    border-radius: 8px !important;
    border: 1px solid #E5E7EB !important;
    background: #FFFFFF !important;
    padding: 0 10px !important;
    display: flex !important;
    align-items: center !important;
    font-size: 13px !important;
    color: #374151 !important;
    box-shadow: none !important;
  }
  &:hover .ant-select-selector { border-color: #A5B4FC !important; }
  .ant-select-focused .ant-select-selector { border-color: #4F46E5 !important; }
  .ant-select-selection-item { line-height: 34px !important; }
  .ant-select-arrow { color: #6B7280 !important; }
`;

/* ── Edit-icon button (kept for compatibility with existing JSX) ── */
export const IconDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const OptionButton = styled.button`
  height: 32px;
  width: 32px;
  border-radius: 8px;
  border: 1px solid #E4E9F8;
  background: #F8F9FF;
  color: #6366F1;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;

  &::after {
    content: "✎";
    font-size: 14px;
  }

  &:hover {
    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
    color: #fff;
    border-color: transparent;
  }
`;